var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        title: "导入" + _vm.crmTypeName,
        "append-to-body": true,
        "close-on-click-modal": false,
        width: "750px",
      },
      on: { close: _vm.closeView },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-body" },
        [
          _c(
            "el-steps",
            { attrs: { active: _vm.stepsActive, simple: "" } },
            _vm._l(_vm.stepList, function (item, index) {
              return _c("el-step", {
                key: index,
                attrs: {
                  title: item.title,
                  icon: item.icon,
                  status: item.status,
                },
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.stepsActive == 1
            ? _c("div", { staticClass: "step-section" }, [
                _c("div", { staticClass: "sections" }, [
                  _c("div", { staticClass: "sections__title" }, [
                    _vm._v("一、请按照数据模板的格式准备要导入的数据。"),
                    _c(
                      "span",
                      { staticClass: "download", on: { click: _vm.download } },
                      [
                        _vm._v(
                          "点击下载《" + _vm._s(_vm.crmTypeName) + "导入模板》"
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sections__tips" }, [
                    _vm._v("导入文件请勿超过2MB（约10,000条数据）"),
                  ]),
                ]),
                _vm._v(" "),
                _vm.config.repeatHandleShow
                  ? _c("div", { staticClass: "sections" }, [
                      _c("div", { staticClass: "sections__title" }, [
                        _vm._v(
                          "二、请选择数据重复时的处理方式" +
                            _vm._s(
                              _vm.config.repeatRuleShow
                                ? `（查重规则：【${_vm.fieldUniqueInfo}】）`
                                : ""
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.config.repeatRuleShow
                        ? _c("div", { staticClass: "sections__tips" }, [
                            _vm._v(
                              "查重规则为：添加" +
                                _vm._s(_vm.crmTypeName) +
                                "时所需填写的所有唯一字段，当前设置唯一字段为：" +
                                _vm._s(_vm.fieldUniqueInfo)
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.repeatHandling,
                                callback: function ($$v) {
                                  _vm.repeatHandling = $$v
                                },
                                expression: "repeatHandling",
                              },
                            },
                            _vm._l(
                              [
                                { name: "覆盖系统原有数据", value: 1 },
                                { name: "跳过", value: 0 },
                              ],
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.name,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "sections" }, [
                  _c("div", { staticClass: "sections__title" }, [
                    _vm._v(
                      _vm._s(_vm.config.repeatHandleShow ? "三" : "二") +
                        "、请选择需要导入的文件"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "flexbox",
                        { staticClass: "file-select" },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.file.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.file, "name", $$v)
                              },
                              expression: "file.name",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.selectFile },
                            },
                            [_vm._v("选择文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.config.ownerSelectShow
                  ? _c("div", { staticClass: "sections" }, [
                      _c("div", { staticClass: "sections__title" }, [
                        _vm._v(
                          "四、请选择负责人（负责人为必填字段，若不填写，则会导致导入失败）"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _c(
                          "div",
                          { staticClass: "user-cell" },
                          [
                            _c("xh-user-cell", {
                              attrs: { value: _vm.user },
                              on: { "value-change": _vm.userSelect },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.config.poolSelectShow
                  ? _c("div", { staticClass: "sections" }, [
                      _c("div", { staticClass: "sections__title" }, [
                        _vm._v("四、请选择公海"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _c(
                          "div",
                          { staticClass: "user-cell" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.pool_id,
                                  callback: function ($$v) {
                                    _vm.pool_id = $$v
                                  },
                                  expression: "pool_id",
                                },
                              },
                              _vm._l(_vm.poolList, function (item) {
                                return _c("el-option", {
                                  key: item.pool_id,
                                  attrs: {
                                    label: item.pool_name,
                                    value: item.pool_id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm.stepsActive == 2
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "step-section",
                  attrs: {
                    "element-loading-text": _vm.importLoadingText,
                    "element-loading-spinner": "el-icon-loading",
                  },
                },
                [
                  _c("div", { staticClass: "step-section__tips" }, [
                    _vm._v(
                      "当前数据正在导入，您可以点击【最小化】隐藏该页面，数据导入不受影响。"
                    ),
                  ]),
                ]
              )
            : _vm.stepsActive == 3
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "step-section",
                },
                [
                  _c(
                    "div",
                    { staticClass: "result-info" },
                    [
                      _c("i", {
                        staticClass: "wk wk-success result-info__icon",
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "result-info__des" }, [
                        _vm._v("数据导入完成"),
                      ]),
                      _vm._v(" "),
                      _vm.resultData
                        ? _c(
                            "p",
                            { staticClass: "result-info__detail" },
                            [
                              _vm._v("导入总数据"),
                              _c(
                                "span",
                                { staticClass: "result-info__detail--all" },
                                [_vm._v(_vm._s(_vm.resultData.total))]
                              ),
                              _vm._v("条，"),
                              _vm.resultData.cover
                                ? [
                                    _vm._v("覆盖"),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "result-info__detail--suc",
                                      },
                                      [_vm._v(_vm._s(_vm.resultData.done))]
                                    ),
                                    _vm._v("条，"),
                                  ]
                                : _vm._e(),
                              _vm._v("导入成功"),
                              _c(
                                "span",
                                { staticClass: "result-info__detail--suc" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.resultData.total -
                                        _vm.resultData.error
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("条，导入失败"),
                              _c(
                                "span",
                                { staticClass: "result-info__detail--err" },
                                [_vm._v(_vm._s(_vm.resultData.error))]
                              ),
                              _vm._v("条"),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.resultData && _vm.resultData.error > 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "result-info__btn--err",
                              attrs: { type: "text" },
                              on: { click: _vm.downloadErrData },
                            },
                            [_vm._v("下载错误数据")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            attrs: { id: "importInputFile", type: "file" },
            on: { change: _vm.uploadFile },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.config.historyShow
            ? _c(
                "el-popover",
                {
                  attrs: {
                    placement: "top",
                    width: "800",
                    "popper-class": "no-padding-popover",
                    trigger: "click",
                  },
                  model: {
                    value: _vm.historyPopoverShow,
                    callback: function ($$v) {
                      _vm.historyPopoverShow = $$v
                    },
                    expression: "historyPopoverShow",
                  },
                },
                [
                  _c("c-r-m-import-history", {
                    attrs: {
                      show: _vm.historyPopoverShow,
                      "crm-type": _vm.crmType,
                      props: _vm.props,
                    },
                    on: {
                      close: function ($event) {
                        _vm.historyPopoverShow = false
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "history-btn",
                      attrs: { slot: "reference", type: "text" },
                      slot: "reference",
                    },
                    [_vm._v("查看历史导入记录")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              class: { "is-hidden": !_vm.showCancel },
              on: { click: _vm.closeView },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _vm.sureTitle
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sureClick } },
                [_vm._v(_vm._s(_vm.sureTitle))]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }